import React from 'react';
import { RoadPavement } from '../../../../../../../services/types/Calculator';
import RoadPavementDetailsBase from './RoadPavementDetailsBase';

interface Props {
  roadPavement: RoadPavement;
}

const RoadPavementDetails: React.FC<Props> = ({ roadPavement }) => {
  const calculateFactorTotalArea = (rp: RoadPavement, measurementSystemId: number): number =>
    measurementSystemId === 2 ? rp.factorValue : rp.factorValue / rp.sqFeetToSqMeters;

  const calculateFactorValue = (rp: RoadPavement): number =>
    rp.isTotalAreaKnown ? rp.factorValue : rp.factorValue / rp.sqFeetToSqMeters;

  return (
    <RoadPavementDetailsBase
      roadPavement={roadPavement}
      calculateFactorTotalArea={calculateFactorTotalArea}
      calculateFactorValue={calculateFactorValue}
    />
  );
};

export default RoadPavementDetails;
